import { useEffect, useContext } from "react";
import { StoreContext } from "./../../store/Store";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import { useCookies } from "react-cookie";
import { useParams } from "react-router";
import CloseIcon from "@mui/icons-material/Close";
import { useRedirect } from "react-admin";
import { routePaths } from "../../baseLayout/SidebarMenu";
import { APIContext } from "../../store/APIStore";
import IframeResizer from 'iframe-resizer-react'
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import { badgeDesigner as classes } from "./styles";

const BadgeDesigner = () => {
  const [state, dispatch] = useContext(StoreContext);
  const api = useContext(APIContext);
  const [, setCookie, ] = useCookies();

  const { eventId, templateId } = useParams() as any;
  
  const redirect = useRedirect();

  useEffect(() => {
    if (eventId && !state.selectedEvent) {
      fetchSelectedEvent();
    }
    setBadgeDesignerCookies();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.selectedEvent]);

  const fetchSelectedEvent = async () => {
    try {
      const event = await api.eventService.getEvent({ id: eventId });
      dispatch({ type: "SET_SELECTED_EVENT", payload: event });
    } catch (error: any) {
      console.log(error);
    }
  };

  const setBadgeDesignerCookies = () => {
    const session = localStorage.getItem("fielddrive-session");
    if (session) {
      // set cookies by using the localstorage values
      setCookie(
        "fielddrive-session",
        localStorage.getItem("fielddrive-session"),
        { path: "/" }
      );
      setCookie("fielddrive-token", localStorage.getItem("fielddrive-token"), {
        path: "/",
      });
      setCookie(
        `${JSON.parse(session).userId}fielddrive-event-selected`,
        state.selectedEvent?.id,
        { path: "/" }
      );
    }
  };

  return (
    <Box>
      <Box sx={classes.topActions}>
        <FdTypography label="Badge Designer" component="h3" variant="h3" />
        <IconButton
          aria-label="close"
          onClick={() => {
            redirect(
              `/${routePaths.EVENTS}/${state.selectedEvent?.id}/${routePaths.BADGE_TEMPLATES}`
            );
          }}
          size="large">
          <CloseIcon />
        </IconButton>
      </Box>
      {/* the portal application and the old badge designer must be on the same domain */}
      <IframeResizer
        heightCalculationMethod="taggedElement"
        src={`${api.badgeDesignerUrl}/index.html${templateId ? "?templateId=" + templateId : ""}`}
        style={{ border: 0, width: '1px', minWidth: '100%', overflow: 'scroll', minHeight: '100vh' }}
      />
      {/* <iframe
        id="badgeDesignerIframe"
        src={`${api.badgeDesignerUrl}/index.html${templateId ? "?templateId=" + templateId : ""
          }`}
        width="100%"
        height="1000"
        style={{ border: 0 }}
      ></iframe> */}
    </Box>
  );
};

export default BadgeDesigner;
